import Seo from "@/components/feature/Seo";
import Reveal from "@/components/base/Reveal";
import HeroSection from "@/pages/home/components/HeroSection";
import FeaturedPicks from "@/pages/home/components/FeaturedPicks";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import LatestFeed from "@/pages/home/components/LatestFeed";
import DepthSpot from "@/pages/home/components/DepthSpot";
import Testimonials from "@/pages/home/components/Testimonials";
import FaqPreview from "@/pages/home/components/FaqPreview";
import SubscribeBand from "@/pages/home/components/SubscribeBand";
import { faqs, SITE_URL, siteConfig } from "@/mocks/site";

export default function Home() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: siteConfig.name,
      url: `${SITE_URL}/`,
      description: siteConfig.description,
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: `${SITE_URL}/today?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: siteConfig.name,
      url: `${SITE_URL}/`,
      email: siteConfig.contactEmail,
      description: siteConfig.tagline,
      foundingDate: String(siteConfig.foundedYear),
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.slice(0, 4).map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    },
  ];

  return (
    <>
      <Seo
        title="黑料看点 - 每日精选热点看点与今日必看推荐"
        description="黑料看点每日精选全网文娱与网络热点，今日看点必看推荐每日更新，综艺、影视、明星动态、网络热梗一站聚合，一页看完当日精华。"
        keywords="黑料看点,黑料看点每日精选,黑料看点今日看点,黑料看点每日更新,黑料看点必看"
        path="/"
        jsonLd={jsonLd}
      />
      <HeroSection />
      <Reveal><FeaturedPicks /></Reveal>
      <Reveal><CategoryGrid /></Reveal>
      <Reveal><LatestFeed /></Reveal>
      <Reveal><DepthSpot /></Reveal>
      <Reveal><Testimonials /></Reveal>
      <Reveal><FaqPreview /></Reveal>
      <SubscribeBand />
    </>
  );
}